export interface ContractsAccessModel {
  // General access section.
  canReadContracts: boolean;
  canReadContractById: boolean;
  canWriteContracts: boolean;
  canSaveForce: boolean;
  canReadDebts: boolean;
  canWriteDebts: boolean;
  canRemoveTemplate: boolean;
}


export const CONTRACTS_ACCESS_DEFAULT: ContractsAccessModel = {
  canReadContracts: false,
  canReadContractById: false,
  canWriteContracts: false,
  canSaveForce: false,
  canReadDebts: false,
  canWriteDebts: false,
  canRemoveTemplate: false
};
